import { InputHTMLElement } from "components/input/baseHTMLElementInput";
import template from "components/input/baseInputInput.hbs";
import { Tooltip } from "components/components/tooltip/tooltip";
import IMask from "imask";

export class TextInputElement extends InputHTMLElement {

  private _uppercase: boolean;
  private _allowedPattern: string = null;
  private mask: IMask.InputMask<IMask.MaskedRegExp>;

  constructor() {
    super();

    this._uppercase = (this.getAttribute("uppercase") === 'true');
    this._allowedPattern = this.getAttribute("allowedPattern");

    const optTemplate = {
      "prefixId": "ti",
      "id": this.getAttribute("_id"),
      "className": "c-text-input__input o-form-component__input  o-form-component__input-group__input",
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
      "maxlength": this.getAttribute("maxlength"),
      "style": this.getAttribute("_style"),
      "autocomplete": this.getAttribute("autocomplete")
    } as any;

    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");
    this.mask = this.initMask();

    this.bindEvents();
    Tooltip.bindElement(this);
  }

  private bindEvents(): void {

    this.genericBindEvents();

    this.addEventFocusin_selectContent();
  }

  private initMask(): IMask.InputMask<IMask.MaskedRegExp> {
    if (this._allowedPattern != null && this._allowedPattern !== "") {
      const maskOptions = {
        mask: new RegExp(this._allowedPattern),
      } as any;
      return IMask(this.input, maskOptions);
    }
  }

  public set data(v: string) {
    this.input.value = this._uppercase ? (v?.toString().toUpperCase() ?? null) : (v?.toString() ?? null);
    this.initialValue.value = this.data;
    this.mask?.updateValue();
  }

  public get data(): string {
    let v = this.input.value;
    if (v === "") {
      return null;
    } else {
      return this._uppercase ? v.toUpperCase() : v;
    }
  }
}

export function initTextInputWebComponent() {
  window.customElements.define("s6-text-input", TextInputElement);
}
